import isURL from './is-url';
import isPhoneNumber from './is-phone-number';
import isEmail from './is-email';
import isIdentificator from './is-identificator';
import isAnchor from './is-anchor';

const isFullyURL = (str) => {
  if (isURL(str)) return true;
  try {
    const link = new URL(str);
    const { protocol, hash, pathname } = link;
    switch (protocol) {
      case 'tel:':
        return isPhoneNumber(pathname);
      case 'mailto:':
        return isEmail(pathname);
      case 'about:':
        return isAnchor(str) || isIdentificator(hash);
      default:
        return false;
    }
  } catch (_) {
    return isAnchor(str) || isIdentificator(str);
  }
};

export default isFullyURL;
